import { format } from 'date-fns'
import { CircleCheck } from 'lucide-react'

import { parseUtcDate } from '@/lib/date-utils'
import { cn } from '@/lib/utils'

type Props = {
  /** 0 なら未訪問としてバッジを出さない */
  visitCount?: number | null
  lastVisitedAt?: string | null
  className?: string
}

/** Google の場所検索の候補に「行ったことがある」ことを示すバッジ */
export const VisitedPlaceBadge = ({ visitCount, lastVisitedAt, className }: Props) => {
  if (!visitCount) return null

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-emerald-500/15 px-1.5 py-0.5 text-[10px] leading-none font-medium text-emerald-700 dark:text-emerald-400',
        className,
      )}
    >
      <CircleCheck className="size-3 shrink-0" />
      訪問{visitCount}回
      {lastVisitedAt && <span className="opacity-70">{format(parseUtcDate(lastVisitedAt), 'yyyy/M/d')}</span>}
    </span>
  )
}
